<template>
  <v-card class="card-shadow rounded-card">
    <v-card-text class="text--primary">
      <v-row dense>
        <v-col cols="12" sm="8" class="title font-weight-bold">
          {{ fornecedorDetalhes.pessoa.nome }}
        </v-col>
        <v-col cols="12" sm="4" class="text-right">
          Atualizado em {{ fornecedorDetalhes.dataAtualizadoReceita | date(true) }}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-icon left>mdi-domain</v-icon>{{ fornecedorDetalhes.pessoa.cnpj | cnpj }}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-icon>mdi-map-marker</v-icon>
          {{ fornecedorDetalhes.endereco | endereco }}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6" v-if="fornecedorDetalhes.pessoa.email">
          <v-icon left>mdi-email</v-icon>{{ fornecedorDetalhes.pessoa.email }}
        </v-col>
        <v-col cols="12" sm="6" v-if="fornecedorDetalhes.pessoa.telefone">
          <v-icon left>mdi-phone</v-icon>{{ fornecedorDetalhes.pessoa.telefone | phone }}
        </v-col>
      </v-row>
      <template v-if="fornecedorDetalhes.atividadePrincipal">
        <v-row dense class="mt-3">
          <v-col cols="12">
            <v-subheader class="font-weight-bold text--primary">
              <v-icon left>mdi-arrow-down</v-icon>
              Atividades
            </v-subheader>
          </v-col>
        </v-row>
        <v-row dense class="ml-5">
          <v-col cols="12">
            {{ fornecedorDetalhes.atividadePrincipal.descricao }}
            <v-chip small label color="primary" class="ml-2">Principal</v-chip>
          </v-col>
        </v-row>
        <v-row dense class="ml-5"
               v-for="atividade in fornecedorDetalhes.atividadesSecundarias"
               :key="atividade.id">
          <v-col cols="12">
            {{ atividade.descricao }}
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>

export default {
  props: {
    fornecedorDetalhes: {
      type: Object,
      required: true,
    },
  },
};
</script>
